import { Roles } from '@/common/constants';
import { useHasAccess } from '@/modules/core/hooks';

const useIsLimitedAccess = () => {
  const isLimitedAccess = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);
  return isLimitedAccess;
};

export default useIsLimitedAccess;
